import React, { Component } from 'react'
import { jsonFromUrlParam } from '../../utils'
import { Route, NavLink, HashRouter, Router } from "react-router-dom";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import './style.css'

export default class Search extends Component {
    constructor(props) {
        super(props)

        this.state = {
            keyword: "",
            city: "",
            zipcode: "",
            location: "",
            longtitude: 10,
            latitude: 106,
            activeTab: 2
        }

        this.handleSelect = this.handleSelect.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.renderGeocodeFailure = this.renderGeocodeFailure.bind(this)
        this.renderGeocodeSuccess = this.renderGeocodeSuccess.bind(this)

    }

    componentDidMount() {
        this.setState({
            geocodeResults: this.renderGeocodeSuccess(this.state.latitude, this.state.longtitude),
            loading: false,
            address: (this.props.initValue) ? this.props.initValue : "",
            longtitude: (this.props.longtitude) ? this.props.longtitude : "",
            latitude: (this.props.latitude) ? this.props.latitude : "",
            keyword: (this.props.keyword) ? this.props.keyword : "",
            city: (window.location.search) ? (((window.location.search.split('&')[2]) ? ((window.location.search.split('&')[2].split('=')[1] === "2")) : "") ? decodeURI(window.location.search.split('&')[1].split('=')[1]) : "") : '',
            zipcode: (window.location.search) ? (((window.location.search.split('&')[2]) ? (window.location.search.split('&')[2].split('=')[1] === "3") : "") ? ((window.location.search.split('&')[1]) ? (window.location.search.split('&')[1].split('=')[1]) : "") : "") : '',
            // activeTab: parseInt((window.location.search) ? ((window.location.search.split('&')[2]) ? (window.location.search.split('&')[2].split('=')[1]) : "") : '1')
        })
    }

    onKeyWordChange() {
        this.setState({
            keyword: this.refs.keyword.value
        })
    }
    onLocationChange() {
        this.setState({
            location: this.refs.location.value
        })
    }

    onCityChange() {
        this.setState({
            city: this.refs.city.value
        })
    }
    onZipCodeChange() {
        this.setState({
            zipcode: this.refs.zipcode.value
        })
    }

    handleSelect(address) {
        this.setState({
            address,
            loading: true
        })

        geocodeByAddress(address)
            .then((results) => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                this.setState({
                    geocodeResults: this.renderGeocodeSuccess(lat, lng),
                    loading: false
                })
            })
            .catch((error) => {
                this.setState({
                    geocodeResults: this.renderGeocodeFailure(error),
                    loading: false
                })
            })
    }

    handleChange(address) {
        this.setState({
            address,
            geocodeResults: null
        })
    }
    renderGeocodeFailure(err) {
        return (
            <div className="alert alert-danger" role="alert">
                <strong>Error!</strong> {err}
            </div>
        )
    }
    renderGeocodeSuccess(lat, lng) {
        this.setState({
            longtitude: lng,
            latitude: lat
        })
    }
    handleSearch() {
        if (this.setState.keyword === "") {
            alert("Please enter what you want to find.")
            return
        }
        if (this.state.city === "") {
            alert("Please enter location you want to find.")
            return
        }
        this.props.history.push("/spa?keyword="
            + this.state.keyword
            // + ((activeTab === 1) ? ("&location=" + this.state.address) : "")
            + "&location=" + this.state.city
            // + ((activeTab === 3) ? ("&location=" + ((this.state.zipcode) ? this.state.zipcode : "")) : "")
            // + "&type=" + activeTab
        )
    }

    render() {
        const cssClasses = {
            root: 'form-group',
            input: 'Demo__search-input',
            autocompleteContainer: 'Demo__autocomplete-container',
        }
        const AutocompleteItem = ({ formattedSuggestion }) => (
            <div className="Demo__suggestion-item">
                <i className='fa fa-map-marker Demo__suggestion-icon' />
                <strong>{formattedSuggestion.mainText}</strong>{' '}
                <small className="text-muted">{formattedSuggestion.secondaryText}</small>
            </div>
        )
        const inputProps = {
            type: "text",
            value: this.state.address,
            onChange: this.handleChange,
            autoFocus: false,
            placeholder: "Address",
            name: 'Demo__input',
            id: "address_map",
        }

        let {
            activeTab
        } = this.state;
        return (
            <div id="search-content-all">
                <div className="key-word">
                    <label>I want:</label>
                    <input type="text"
                        value={this.state.keyword} ref="keyword"
                        placeholder="nails, spa, salon, masage, etc"
                        className="ui-autocomplete-input"
                        onChange={
                            event => {
                                this.setState({
                                    keyword: event.target.value
                                })
                            }}
                        onKeyPress={event => {
                            if (event.key === 'Enter') {
                                this.handleSearch();
                            }
                        }
                        }
                    />
                </div>
                <div className='address_container'>
                    <div className="address_container_menu">
                        <span className={(activeTab === 1) ? "menu_item_1 active" : "menu_item_1"} onClick={() => this.setState({ activeTab: 1 })}>Near:</span>
                        {/* <span className={(activeTab === 2) ? "menu_item_2 active" : "menu_item_2"} onClick={() => this.setState({ activeTab: 2 })}>City</span>
                        <span className={(activeTab === 3) ? "menu_item_3 active" : "menu_item_3"} onClick={() => this.setState({ activeTab: 3 })}>Zipcode</span> */}
                    </div>
                    <div className="address_container_detail">
                        {
                            (activeTab === 1) ? < div className="address">
                                <PlacesAutocomplete
                                    value={this.props.initValue}
                                    onSelect={this.handleSelect}
                                    autocompleteItem={AutocompleteItem}
                                    onEnterKeyDown={this.handleSelect}
                                    classNames={cssClasses}
                                    inputProps={inputProps}
                                    onChange={value => this.setState({ address: value })}
                                />
                                {this.state.loading ? <div><i className="fa fa-spinner fa-pulse fa-3x fa-fw Demo__spinner" /></div> : null}
                                {!this.state.loading && this.state.geocodeResults ?
                                    <div className='geocoding-results'>{this.state.geocodeResults}</div> :
                                    null}
                            </div> : ""
                        }
                        {
                            (activeTab === 2) ? <div className="city">
                                <input type="text"
                                    value={this.state.city} ref="city"
                                    placeholder="Address, city, zipcode, ..."
                                    className="ui-autocomplete-input"
                                    onChange={event => {
                                        this.setState({
                                            city: event.target.value
                                        })
                                    }}
                                    onKeyPress={event => {
                                        if (event.key === 'Enter') {
                                            this.handleSearch();
                                        }
                                    }} />
                            </div> : ""
                        }
                        {
                            (activeTab === 3) ? <div className="zipcode">
                                <input type="text" value={this.state.zipcode} ref="zipcode" placeholder="Zipcode" className="ui-autocomplete-input" onChange={this.onZipCodeChange.bind(this)} />
                            </div> : ""
                        }
                    </div>
                </div>
                <NavLink
                    to={"/spa?keyword="
                        + this.state.keyword
                        // + ((activeTab === 1) ? ("&location=" + this.state.address) : "")
                        + ((activeTab === 2) ? ("&location=" + ((this.state.city) ? this.state.city : "")) : "")
                        // + ((activeTab === 3) ? ("&location=" + ((this.state.zipcode) ? this.state.zipcode : "")) : "")
                        + "&type=" + activeTab
                    }
                    className="reset_f5"
                    onClick={() => this.setState({
                        longtitude: null,
                        latitude: null
                    })}>
                    <button type="submit" className="green large" >Find {(this.props.showSearchIcon) ? <i className="fa fa-search"></i> : ""}</button>
                </NavLink>
            </div >

        )

    }
}


// WEBPACK FOOTER //
// ./src/components/search/index.js